module.exports = __webpack_public_path__ + "img/2.37ecf3ec.jpg";